module.exports = __webpack_public_path__ + "img/en-tur-i-tivoli-4.ff44da3e.png";